export default {
  title: "Wallet kartasi dizayni",
  emptyState: {
    description:
      "Sahifaga kirish uchun «Promo» yoki «Pro+» tarifini xarid qilishingiz kerak",
    buttonText: "Tariflarga",
  },
  tradingPoint: "Savdo nuqtasi",
  actions: {
    resetDesign: "Asosiy dizaynga qaytarish",
    saveChanges: "O‘zgarishlarni saqlash",
  },
  walletCardPreview: {
    clientName: "Mijoz ismi",
    balance: "Balans",
    discount: "Chegirma",
  },
  walletCardSettings: {
    colors: {
      title: "Wallet kartasi ranglari",
      background: "Fon rangi",
      text: "Matn rangi",
    },
    logo: {
      title: "Savdo nuqtasi logotipi",
      noLogo: "Logotip yo‘q",
      hasLogo: "Logotip mavjud",
      aspectRatio: "Logotip nisbati — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 fayl, 5 MB gacha",
    },
    stripe: {
      title: "Orqa fon",
      noStripe: "Orqa fon yo‘q",
      image: "Rasm",
      colorFill: "Rang bilan to‘ldirish",
      aspectRatio: "Nisbati — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 fayl, 5 MB gacha",
      color: "Orqa fon rangi",
    },
  },
};
